import { Box, Chip, Stack, Typography } from '@mui/material'
import PropTypes from 'prop-types'
import {
    accentColorOptions,
    accentColorValues
} from '@/theme/colors'

export const OptionsColorPreset = (props) => {
    const { onChange, value } = props

    return (
        <Stack spacing={1} sx={{ display: 'block', m: 0, p: 0 }}>
            <Typography
                color="text.secondary"
                variant="overline"
                sx={{ display: 'block', mt: 4 }}
            >
                Accent Color
            </Typography>
            <Stack alignItems="center" direction="row" flexWrap="wrap" gap={1}>
                {accentColorOptions.map((option) => (
                    <Chip
                        icon={
                            <Box
                                sx={{
                                    backgroundColor: option.color,
                                    flexShrink: 0,
                                    height: 24,
                                    width: 36
                                }}
                            />
                        }
                        key={option.value}
                        // label={option.label}
                        onClick={() => onChange?.(option.value)}
                        sx={[
                            {
                                borderColor: 'transparent',
                                borderStyle: 'solid',
                                borderWidth: 2,
                                height: '34px',
                                p: '4px',
                                '& .MuiChip-icon': {
                                    m: 0
                                },
                                '& .MuiChip-label': {
                                    p: 0
                                }
                            },
                            option.value === value && {
                                borderColor: 'primary.main'
                            }
                        ]}
                    />
                ))}
            </Stack>
        </Stack>
    )
}

OptionsColorPreset.propTypes = {
    onChange: PropTypes.func,
    value: PropTypes.oneOf(accentColorValues)
}
